import React from 'react';
import type { ReceptionistDemoState } from '../../receptionist-dashboard/types';
import { EmptyDashboard } from './EmptyDashboard';
import { MatureDashboard } from './MatureDashboard';
import { ReceptionistDashboardFooter } from './ReceptionistDashboardFooter';
import { TrialDashboard } from './TrialDashboard';

export interface ReceptionistDashboardViewProps {
  demoState?: ReceptionistDemoState;
}

export function ReceptionistDashboardView({ demoState = 'mature' }: ReceptionistDashboardViewProps) {
  return (
    <div className="mx-auto w-full max-w-[1380px] px-[26px] pb-8 pt-5">
      {demoState === 'mature' ? (
        <MatureDashboard />
      ) : demoState === 'trial' ? (
        <TrialDashboard />
      ) : (
        <EmptyDashboard />
      )}
      <ReceptionistDashboardFooter state={demoState} />
    </div>
  );
}
